import axios from 'axios';
import apiConfig from '../api.config';

export default function addIhClientHotelRequest({ hotelId, clientId, customHotelId }) {
  const {
    host,
    URIs: { iHClientHotel },
  } = apiConfig;

  const uri = `${host}${iHClientHotel}`;

  return axios
    .put(uri, JSON.stringify({ hotelId, clientId, customHotelId }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
